import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAccountManagerEmailEdit({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/accountManagerEmailEdit"));
  console.log("Loading", AsyncAccountManagerEmailEdit.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAccountManagerEmailEdit;
